import { defineIntegration, GLOBAL_OBJ } from '@sentry/core';

// The vue integration is actually set up in the Sentry Client Module. There it is set up as soon as the nuxt app object is available.
// However, we need to export the vueIntegration from the Client SDK. This means all this integration does is store away
// its options for the Sentry Client Module to pick them up when initializing the actual vueIntegration.

/**
 * Add additional error and span instrumentation specialized for Vue.
 */
const vueIntegration = defineIntegration((options = {}) => {
  return {
    // NOTE: This name is different from the original vueIntegration's name.
    name: 'NuxtVueIntegration',
    setup() {
      (GLOBAL_OBJ )._sentryNuxtVueIntegrationOptions = options;
    },
  };
});

export { vueIntegration };
//# sourceMappingURL=vueIntegration.js.map
